import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from '@material-ui/core'
import { AxiosError } from 'axios'
import React from 'react'
import toast from 'react-hot-toast'
import { useMutation } from 'react-query'
import { Flag } from 'src/api/models'
import { handleErrorMessage, Notification } from 'src/components/Notification'
import { useForm } from 'src/forms'
import { setApiErrors } from 'src/forms/errors'
import { skuit } from 'src/services/skuit'
import * as yup from 'yup'

interface FlagData {
  name: string
}

const flagSchema = yup.object().shape({
  name: yup.string().label('Name').required(),
})

interface FlagDialogProps {
  open: boolean
  handleClose: () => void
  onSave?: (obj: any) => void
}

export const FlagDialog = ({ open, onSave, handleClose }: FlagDialogProps) => {
  const { Form, Field, data: formData } = useForm(flagSchema)

  const { mutate: createFlag } = useMutation(skuit.sc.freight.orders.flags.create, {
    onSuccess: (newFlag: Flag) => {
      toast.success(() => <Notification message={`Successfully created flag: ${newFlag.name}!`} />)
      onSave?.(newFlag)
    },
    onError: (error: AxiosError) => {
      handleErrorMessage(error, 'creat', 'Flag')
      setApiErrors(formData.setError, error)
    },
  })

  const onSubmit = (data: FlagData) => {
    createFlag(data)
    handleClose()
  }

  return (
    <Dialog open={open} onClose={handleClose}>
      <Form onSubmit={onSubmit}>
        <DialogTitle>Add a new flag</DialogTitle>
        <DialogContent>
          <DialogContentText>Did you miss any flag in our list? Please, add it!</DialogContentText>

          <Field
            name="name"
            renderField={({ name, value, setValue, error }) => (
              <TextField
                inputRef={(input) => input && input.focus()}
                id={name}
                name={name}
                label="Name"
                error={!!error}
                helperText={error}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setValue(name, e.target.value)
                }
                value={value || ''}
              />
            )}
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button type="submit">Add</Button>
        </DialogActions>
      </Form>
    </Dialog>
  )
}
